import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api, fmtDate, inr, STATUS_CLASS, STATUS_LABEL } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Account() {
  const { user } = useAuth();
  const { data: orders = [], isLoading } = useQuery({ queryKey: ["orders"], queryFn: async () => (await api.get("/orders")).data });

  return (
    <div className="mx-auto max-w-5xl px-5 py-12 sm:px-8 md:py-20" data-testid="account-page">
      <p className="eyebrow">My shelf</p>
      <h1 className="mt-3 text-4xl font-medium tracking-tight">Hello, {user?.name?.split(" ")[0]}.</h1>
      <p className="mt-2 text-sm text-muted-foreground">{user?.email} · Ebooks here can be re-downloaded any time.</p>
      {isLoading ? (
        <p className="mt-12 text-sm text-muted-foreground">Loading your orders…</p>
      ) : orders.length === 0 ? (
        <div className="mt-16 rounded-3xl bg-white p-12 text-center ring-1 ring-border/70" data-testid="orders-empty">
          <p className="font-display text-2xl">No orders yet.</p>
          <Link to="/#shelf" className="mt-6 inline-block rounded-full bg-foreground px-6 py-3 text-sm font-semibold text-white" data-testid="orders-browse-link">Browse the shelf</Link>
        </div>
      ) : (
        <ul className="mt-12 space-y-4" data-testid="orders-list">
          {orders.map((o) => (
            <li key={o.order_id}>
              <Link to={`/account/orders/${o.order_id}`} className="flex flex-wrap items-center gap-5 rounded-2xl bg-white p-5 ring-1 ring-border/70 transition-[box-shadow,transform] duration-200 hover:-translate-y-0.5 hover:shadow-lg" data-testid={`order-row-${o.order_id}`}>
                <div className="flex -space-x-3">
                  {o.items.slice(0, 3).map((it) => <img key={it.book_id + it.format} src={it.cover_url} alt="" className="h-16 w-11 rounded object-cover shadow ring-2 ring-white" />)}
                </div>
                <div className="min-w-0 flex-1">
                  <p className="truncate font-display text-lg font-medium">{o.items.map((i) => i.title).join(", ")}</p>
                  <p className="mt-1 text-xs text-muted-foreground">{o.order_id} · {fmtDate(o.created_at)} · {o.items.length} item{o.items.length > 1 && "s"}</p>
                </div>
                <span className={`rounded-full px-3 py-1 text-xs font-semibold ${STATUS_CLASS[o.status]}`} data-testid={`order-status-${o.order_id}`}>{STATUS_LABEL[o.status]}</span>
                <span className="font-semibold">{inr(o.total)}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
